// services/productBookingListService.js
import { api, API_URL } from "../config/apiConfig";
import { handleUnauthorizedOrForbidden } from "../config/varConfig";

export const getProductBookingList = async (params = {}) => {
  try {
    const response = await api.get(`${API_URL}/product/transaction`, {
      params: {
        page: params.page || 1,
        search: params.search || "",
        orderId: params.orderId || "",
        startDate: params.startDate || "",
        endDate: params.endDate || "",
        sortOrder: params.sortOrder || "desc",
        limit: params.limit || 10,
      },
    });

    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};

// GET COURIER LIST
export const getCouriers = async (transactionId) => {
  try {
    const res = await api.get(`${API_URL}/product/couriers/${transactionId}`);
    return res.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};

// ASSIGN COURIER
export const assignCourier = async ({
  transactionId,
  productIds,
  courierId,
}) => {
  try {
    const res = await api.post(
      `${API_URL}/product/assign_courier/${transactionId}`,
      {
        productIds, // array of product ids
        courierId, // selected courier id
      },
    );

    return res.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};

// SCHEDULE PICKUP
export const schedulePickup = async ({ transactionId, productIds }) => {
  try {
    const res = await api.post(
      `${API_URL}/product/schedule_pickup/${transactionId}`,
      {
        productIds, // array of product ids
      },
    );

    return res.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};

// DOWNLOAD LABEL
export const downloadLabel = async ({ transactionId, productIds }) => {
  try {
    const res = await api.post(
      `${API_URL}/product/download/label`,
      {
        transactionId,
        productIds, // array of product ids
      },
      // DON'T use responseType: "blob" since backend returns JSON
    );

    return res.data; // Returns { success, labelUrl, shipmentIds }
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};

// DOWNLOAD INVOICE
export const downloadInvoice = async ({ transactionId, productIds }) => {
  try {
    const res = await api.post(
      `${API_URL}/product/download/invoice`,
      {
        transactionId,
        productIds, // array of product ids
      },
      // DON'T use responseType: "blob" since backend returns JSON
    );

    return res.data; // Returns { success, invoiceUrl, orderIds, isInvoiceCreated }
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};

// UPDATE DELIVERY STATUS
export const updateDeliveryStatus = async ({ transactionId, payload }) => {
  try {
    const res = await api.put(
      `${API_URL}/product/transaction/${transactionId}/delivery`,
      payload,
    );
    return res.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};

// CANCEL PRODUCT
export const cancelProduct = async ({ transactionId, product, reason }) => {
  try {
    // product is an array: [id] or [id1, id2, id3]
    const res = await api.put(
      `${API_URL}/product/transaction/${transactionId}/cancel`,
      {
        product, // Array of product IDs
        reason,
      },
    );
    return res.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};
